export const defualtMeta = [
	{
		vmid: 'description',
		name: 'description',
		content: '아이알리미 아이앱',
	},
];
